export default "__VITE_ASSET__C8kN3eTc__"